import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";

// Ana sayfa ilk açılışta gerekli olduğu için normal import
import HomePage from "../pages/HomePage";

// Diğer sayfalar sadece ihtiyaç olduğunda yüklenecek
const AboutPage = lazy(() => import("../pages/AboutPage"));
const ContactPage = lazy(() => import("../pages/ContactPage"));
const QuestionPage = lazy(() => import("../pages/QuestionPage"));
const ProjectsPage = lazy(() => import("../pages/ProjectsPage"));

const WebDesignPage = lazy(() => import("../pages/WebDesignPage"));
const ECommercePage = lazy(() => import("../pages/ECommercePage"));
const DomainHostingPage = lazy(() => import("../pages/DomainHostingPage"));
const HostingPage = lazy(() => import("../pages/HostingPage"));
const DomainSSLPage = lazy(() => import("../pages/DomainSSLPage"));
const CorporateEmailPage = lazy(() => import("../pages/CorporateEmailPage"));
const SEOPage = lazy(() => import("../pages/SEOPage"));
const LogoDesignPage = lazy(() => import("../pages/LogoDesignPage"));
const BusinessProfilePage = lazy(() => import("../pages/BusinessProfilePage"));
const GoogleMapsPage = lazy(() => import("../pages/GoogleMapsPage"));

const CustomRoutes = () => {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<HomePage />} />

        <Route path="/web-design" element={<WebDesignPage />} />
        <Route path="/e-ticaret" element={<ECommercePage />} />
        <Route path="/domain-hosting" element={<DomainHostingPage />} />
        <Route path="/hosting" element={<HostingPage />} />
        <Route path="/domain-ssl" element={<DomainSSLPage />} />
        <Route path="/kurumsal-e-posta" element={<CorporateEmailPage />} />
        <Route path="/seo-optimizasyon" element={<SEOPage />} />
        <Route path="/logo-tasarimi" element={<LogoDesignPage />} />
        <Route path="/isletme-profili" element={<BusinessProfilePage />} />
        <Route path="/google-harita-kaydi" element={<GoogleMapsPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/faqs" element={<QuestionPage />} />
      </Routes>
    </Suspense>
  );
};

export default CustomRoutes;